import { type SessionStorageKey } from '@/constant/storage'

const setItem = (key: SessionStorageKey, state: any): void => {
  try {
    sessionStorage.setItem(key, JSON.stringify(state))
  } catch (error) {
    console.error(`Failed to set sessionStorage key: ${key}`, error)
  }
}

const getItem = (key: SessionStorageKey): any | null => {
  try {
    const item = sessionStorage.getItem(key)
    return item ? JSON.parse(item) : null
  } catch (error) {
    console.error(`Failed to get sessionStorage key: ${key}`, error)
    return null
  }
}

const removeItem = (key: SessionStorageKey): void => {
  try {
    sessionStorage.removeItem(key)
  } catch (error) {
    console.error(`Failed to remove sessionStorage key: ${key}`, error)
  }
}

export { setItem, getItem, removeItem }
